import { useState, useMemo } from "react";
import { Autocomplete, TextField, Avatar, CircularProgress, Box, Typography } from "@mui/material";
import { useUsersSearch } from "./useUsersSearch"; // tu hook de búsqueda

export interface UserLite {
  id: number;
  email: string;
  avatarUrl: string | null;
}

interface Props {
  value: UserLite[];
  onChange: (users: UserLite[]) => void;
  error?: boolean;
  helperText?: string | null;
}

export default function RecipientsAutocomplete({ value, onChange, error, helperText }: Props) {
  const [input, setInput] = useState("");

  /* --- backend query (debounced dentro del hook) --- */
  const { data: options = [], isLoading } = useUsersSearch(input);

  /* Evita mostrar usuarios ya seleccionados en la lista */
  const filteredOpts = useMemo(
    () => options.filter((o) => !value.find((v) => v.id === o.id)),
    [options, value]
  );

  return (
    <Autocomplete
      multiple
      options={filteredOpts}
      value={value}
      onChange={(_, newVal) => onChange(newVal)}
      inputValue={input}
      onInputChange={(_, v) => setInput(v)}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      getOptionLabel={(o) => o.email}
      filterSelectedOptions // oculta ya elegidos
      loading={isLoading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Destinatarios"
          error={error}
          helperText={helperText ?? " "}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          <Avatar src={option.avatarUrl ?? undefined} sx={{ width: 24, height: 24, mr: 1 }} />
          <Typography>{option.email}</Typography>
        </Box>
      )}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((opt, i) => (
          <Avatar
            {...getTagProps({ index: i })} // key ya viene dentro
            src={opt.avatarUrl ?? undefined}
            sx={{ mr: 0.5, width: 24, height: 24 }}
            alt={opt.email}
          />
        ))
      }
    />
  );
}
